import { getRequestId } from './requestDiagnostics';

// API handlers return either plain text or a JSON error; render text only.
export const requestErrorMessage = (error, fallback = 'Could not complete this request. Please try again.') => {
  const data = error?.response?.data;
  const message = [data, data?.message, data?.error]
    .find(value => typeof value === 'string' && value.trim()) || fallback;
  const requestId = getRequestId(error);
  return requestId ? `${message} Reference: ${requestId}` : message;
};
